module.exports = __webpack_public_path__ + "img/pic4.9cbb6cef.png";